import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import ExecutionCard from './ExecutionCard';

/**
 * ExecutionHistoryList Component
 *
 * Displays the list of executions or loading/empty states.
 *
 * @param {Object} props
 * @param {Array} props.executions - Array of execution objects
 * @param {boolean} props.loading - Whether data is loading
 * @param {number} props.totalCount - Total count of executions
 */
function ExecutionHistoryList({ executions, loading, totalCount }) {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (executions.length === 0) {
    return (
      <Box textAlign="center" py={4}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No executions found
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This template hasn't been executed yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {totalCount} Execution{totalCount !== 1 ? 's' : ''} Total
      </Typography>
      {executions.map((execution, index) => (
        <ExecutionCard key={execution.id} execution={execution} index={index} />
      ))}
    </Box>
  );
}

export default ExecutionHistoryList;
